export default {
    TYPE_QUESTION: 1,
    TYPE_HEADING: 2,
    TYPE_PLACEHOLDER: 3,
    TYPE_TEXT: 4,
    TYPE_QUANTITY: 5,
    TYPE_DATE: 6,
    TYPE_CERTIFICATE: 7,
}
